import { useEffect, useRef } from 'react';

/**
 * Auto-expands (selects) the first item when:
 * - Items load for the first time
 * - The currently active item is no longer in the list (e.g., division change, deletion)
 * 
 * @param {Array} items - The filtered list of items (e.g., CSI items for current division)
 * @param {string|null} activeId - Currently active/expanded item ID
 * @param {Function} setActiveId - Setter for the active ID
 * @param {Function} [onAutoExpand] - Optional callback when auto-expand triggers (receives the item)
 */
export const useAutoExpandFirstItem = (items, activeId, setActiveId, onAutoExpand) => {
  const prevItemsLenRef = useRef(0);

  useEffect(() => {
    if (!items || items.length === 0) {
      prevItemsLenRef.current = 0;
      return;
    }

    const activeExists = items.some(item => item.id === activeId);

    if (!activeExists) {
      const firstItem = items[0];
      setActiveId(firstItem.id);
      if (onAutoExpand) onAutoExpand(firstItem);
    }

    prevItemsLenRef.current = items.length;
  }, [items, activeId, setActiveId, onAutoExpand]);
};
